export default function useTranslation(key) {
    const translationFile = require("./locales/assets/pl/" + key + ".json");
    const translate = (key, defaultValue = null) => {
        var _a;
        return (_a = translationFile[key]) !== null && _a !== void 0 ? _a : defaultValue;
    };
    return {
        t: translate,
    };
}
